import i18n from "i18next";
import { initReactI18next } from "react-i18next";

import enTranslation from './locales/en.json';
import zhTranslation from './locales/zh.json';
import zhHantTranslation from './locales/zh-hant.json';
import esTranslation from './locales/es.json';
import frTranslation from './locales/fr.json';
import jaTranslation from './locales/ja.json';
import koTranslation from './locales/ko.json';
import thTranslation from './locales/th.json';


i18n
    .use(initReactI18next)
    .init({
        resources:{
            en:{translation:enTranslation},
            zh:{translation:zhTranslation},
            "zh_hant":{translation:zhHantTranslation},
            es:{translation:esTranslation},
            fr:{translation:frTranslation},
            ja:{translation:jaTranslation},
            ko:{translation:koTranslation},
            th:{translation:thTranslation}
        },
        lng: "zh",
        fallbackLng:"zh",
        interpolation:{
            escapeValue:false
        },

    });

export default i18n;